//library
import { useDispatch, useSelector } from "react-redux";
import React,{ useEffect, useMemo, useState } from "react";
import { Link, useLocation, useParams, useSearchParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment/moment";

// Components
import { CamelToSentanceCase } from "../../Utils/utils/CommanFnc";
import defaultConfig from "../../config/Config";
import Table from "../../components/admin/Table";

//Action
import { getSchemeList } from "../../slices/SchemeSlice";

export function List() {
    const dispatch = useDispatch() 
    const params =  useParams() 
    const [searchParams, setSearchParams] = useSearchParams()
    const queryString = Object.fromEntries([...searchParams.entries()])  
    const location = useLocation();

    const data = useSelector((state) => state.scheme)
    const loading = useSelector( (state) => state.scheme.loading )

    const [todayDate, setTodayDate] = useState(new Date()) 
    const [pageName, setPageName] = useState('');
    const [businessData, setBusinessData] = useState([]);
    const [columsData, setColumsData] = useState([]);
  
    const [serachString, setSearchString] = useState({
        date: queryString.date? queryString.date : '',
        endDate: queryString.endDate? queryString.endDate : ''
    })
    const [defaultParams, setDefaultParams] = useState({
        pageLength:defaultConfig.defaultLimit,
        page:1
    });
    
    useEffect( () => {
        const page = location.pathname.split('/').findLast( (item) =>  item );
        setPageName(page)
        setTodayDate(new Date())
    },[location])

    const columns = useMemo(()=>{
        let col = [
        {
            name:"Name",
            sortable: true,
            center: true,
            selector: (row) => row?.name,
        },
        {
            
            name:"Scheme Type",
            sortable: true,
            center: true,
            selector: (row) =>  row.schemeType ,
        },
        {
            
            name:"Partner Type",
            sortable: true,
            center: true,
            selector: (row) => row.partnerType,
        },
        {
            name:"Apply on Location Only",
            cell:(row) => (
              <>
              {row.applyOnLocation?"Yes":"No"}
              </>
            ),
            sortable:true,
            center:true
        },
        {
            name:"Start Date",
            cell:(row) => (
              <>
                {moment(parseInt(row.startDate)).format(defaultConfig.dateFormat)}
              </>
            ),
            sortable:true,
            center:true
        },
        {
          name:"End Date",
          cell:(row) => (
            <>
              {moment(parseInt(row.endDate)).format(defaultConfig.dateFormat)}
            </>
          ),
          sortable:true,
          center:true
      },
        {
            name:"Status",
            selector:(row) => CamelToSentanceCase(row.status),
            sortable:true,
            center:true
        },
        // {
        //     name: "Action",
        //     width:"7%",
        //     button: false,
        //     center: true,
        //     cell: (row) => (
        //     <> 
        //     <Link to={{
        //         pathname: `/orders/view/${row._id}`,
        //         search: "",
        //         hash: ""}}  
        //         replace={true}
        //         state={{ pageName: pageName, page: defaultParams.page, pageLength: defaultParams.pageLength } } className="sidebar-link" data-toggle="tab">
        //         {" "}
        //         <i className="fa fa-eye"></i>{" "}
        //     </Link> 
        //     </>
        //     ),
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        // }
        ];
        
        const fromCol = {
        name:"Order From",
        selector: (row) => row.orderFrom.name,
        sortable: true,
        center: true,
        }

        if (pageName === 'my-received-orders') {
        col.splice(1, 1, fromCol) 
        } else if( pageName === "orders" ) {
        col.splice(1, 0, fromCol)
        }

        return col
    },[defaultParams.page, defaultParams.pageLength, pageName])   
    

    useEffect(()=>{
        if(Object.keys(queryString).length === 0){
        dispatch(getSchemeList({data:{...defaultParams, pageName}}))
        }else{
        setDefaultParams({...defaultParams, ...queryString}) 
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[dispatch, pageName]);

    useEffect( () =>{
        setColumsData(columns)
    },[columns, defaultParams])

    useEffect( ()=>{
        setBusinessData(data)
    },[data])

    const setValue = (value, name) => {
        setSearchString({...serachString, [name]: value})
    }

    const searchInt = () => {
        let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page:1, ...serachString})
        setSearchParams(params)  
        setDefaultParams(params)
        params.date = moment(params.date).format('YYYY-MM-DD')
        params.endDate = moment(params.endDate).format('YYYY-MM-DD')
        dispatch(getSchemeList({data:{...params, pageName}}))
    }

    const setPaginationData = (paginationData) =>{
        const params = {...defaultParams, page:paginationData.page, pageLength:paginationData.pageLength}
        setSearchParams(params)  
        setDefaultParams(params)
    }

    const resetSearch = () =>{
        const queryPrm = {pageLength: defaultConfig.defaultLimit, page:1, date: '', endDate: ''}
        setDefaultParams(queryPrm)
        setSearchParams(queryPrm)
        setSearchString({ date:'', endDate: '' }) 
        dispatch(getSchemeList({data:{...queryPrm, pageName}}))
    }

//   useEffect(()=>{
//     const urlState = { gameType: params.type, page: defaultParams.page, pageLength: defaultParams.pageLength }  
//     const col = 
    
//     console.log(col)
//     setColumns(col)
// },[defaultParams.page])
  return (
    <React.Fragment>
      <div className="revenue-wrapper">
        <div className="row">
          <div className="col-lg-12">
            <div className="card table-card">
              <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-clock"></i> All Scheme </h4>
              </div>
              <div className="row m-3">
                <div className="col-sm-8">
                  <div className="row">
                    <form className="form-inline">
                        <div className="form-group">
                          <div className="mr-1">
                          <label style={{'justifyContent':'left'}} className="text-left" >Name</label>
                            <input type="text" className="form-control" placeholder="Enter Scheme Name"/>

                          </div>
                          <div className="mr-1">
                            <label style={{'justifyContent':'left'}} className="text-left">Start Date</label>
                            
                            <DatePicker 
                              showMonthDropdown 
                              showYearDropdown 
                              className="form-control" 
                              dateFormat="MMM d, yyyy"
                              selected={serachString.date?new Date(serachString.date):''} 
                              onChange={(date) => setValue(date, 'date')}
                              placeholderText="Start Date"
                            />  
                          </div>
                          <div className="mr-1">
                            <label style={{'justifyContent':'left'}}>End Date</label>
                            <DatePicker
                              selected={serachString.endDate?new Date(serachString.endDate):''}
                              className="form-control"
                              onChange={(date) => setValue(date, 'endDate')}
                              minDate={new Date(serachString.date)}
                              showMonthDropdown
                              dateFormat="MMM d, yyyy"
                              showYearDropdown
                              placeholderText="End Date"
                            />
                          </div>
                        </div>
                        <div >
                          <label>&nbsp;</label>
                          <button onClick={searchInt} type="button" className="btn btn-primary btn-lg">
                            <i className="fa fa-search"></i>
                          </button>
                          &nbsp;
                          <button type="reset" onClick={resetSearch} title="Reset" className="btn btn-primary btn-lg">
                            <i className="fas fa-undo"></i>
                          </button>
                        </div>
                      
                    </form>
                  </div>
                </div>
                <div className="col-sm-4 text-right">
                  <Link
                    to={"/scheme/create"}
                    className="button blue-button btn-success"
                    data-toggle="tab"
                  >
                    <i className="fas fa-tag"></i>
                    {" "}
                    Create Scheme{" "}
                  </Link>
                </div>
              </div>
              <Table 
                totalCount={businessData.totalCount}
                type={params.type}
                data={businessData.list} 
                columns={columsData} 
                dataLoadFnc={getSchemeList} 
                extraConfig = {{...defaultParams, pageName}}
                loading={loading}  
                callBack={setPaginationData}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

}